module.exports = __webpack_public_path__ + "img/logo-um-fzv-ang.cab0a437.png";